import React, { useState, useRef, useEffect } from 'react'

type UseCloseProps = {
    onClose: () => void
    targetRef: React.RefObject<HTMLDivElement | null>
}

const useCloseOnClickAway = ({ onClose, targetRef }: UseCloseProps) => {

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                targetRef.current &&
                event.target instanceof Node &&
                !targetRef.current.contains(event.target)
            ) {
                onClose();
            }
        }

        document.addEventListener("mousedown", handleClickOutside, true);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside, true);
        };
    }, [targetRef, onClose])

}

export default useCloseOnClickAway
